import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import MdlSelectSession from "./MdlSelectSession";

const MODAL_RADIUS = 16;
const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

function normalizeExamType(value) {
  const v = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");
  return v === "CLASS_TEST" ? "CLASS_TEST" : "EXAM";
}

const EXAM_TYPES = [
  { value: "EXAM", label: "EXAM" },
  { value: "CLASS_TEST", label: "CLASS_TEST" },
];

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-copy-exam-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.5rem auto 1.25rem;
    max-width: 720px;
  }
  .mdl-copy-exam-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-copy-exam-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    border: 1.5px solid #b3e5fc;
    box-shadow: 0 16px 40px rgba(2, 136, 209, 0.16);
    background: #fff;
  }
  .mdl-copy-exam-dialog .modal-header {
    border: none;
    padding: 18px 22px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-copy-exam-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.6rem;
    font-weight: 400;
  }
  .mdl-copy-exam-dialog .modal-body {
    padding: 18px 20px 12px;
    background:
      radial-gradient(ellipse at top right, rgba(179, 229, 252, 0.45), transparent 42%),
      linear-gradient(180deg, #f7fcff 0%, #ffffff 48%);
  }
  .mdl-copy-exam-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 12px 20px;
    background: #f0f9ff;
  }
  .mce-title {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 24px;
  }
  .mce-title__icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mce-title__text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .mce-title__main {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: 0.01em;
  }
  .mce-title__session {
    font-size: 12px;
    font-weight: 650;
    color: rgba(255,255,255,0.95);
  }
  .mce-title__session strong {
    font-weight: 800;
  }
  .mce-title__hint {
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.84);
    line-height: 1.3;
  }
  .mce-section {
    margin-bottom: 14px;
  }
  .mce-section__label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0 0 6px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #0277bd;
  }
  .mce-section__label span {
    margin-left: auto;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0;
    text-transform: none;
    color: #64748b;
    background: #e1f5fe;
    border: 1px solid #b3e5fc;
    border-radius: 999px;
    padding: 1px 7px;
  }
  .mce-session-btn {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 14px;
    border: 1.5px solid #81d4fa;
    background: linear-gradient(135deg, #e1f5fe 0%, #ffffff 70%);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .mce-session-btn:hover {
    border-color: #03a9f4;
    box-shadow: 0 4px 14px rgba(2, 136, 209, 0.12);
  }
  .mce-session-btn__icon {
    width: 30px;
    height: 30px;
    border-radius: 9px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
  }
  .mce-session-btn__meta {
    flex: 1;
    min-width: 0;
  }
  .mce-session-btn__eyebrow {
    display: block;
    font-size: 9px;
    font-weight: 800;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .mce-session-btn__name {
    display: block;
    font-size: 12px;
    font-weight: 800;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mce-session-btn__status {
    flex-shrink: 0;
    font-size: 9px;
    font-weight: 800;
    padding: 2px 7px;
    border-radius: 999px;
    text-transform: capitalize;
  }
  .mce-session-btn__change {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 800;
    color: #0288d1;
  }
  .mce-empty {
    text-align: center;
    padding: 36px 18px;
    color: #64748b;
    border-radius: 14px;
    background: #f8fafc;
    border: 1.5px dashed #b3e5fc;
  }
  .mce-empty__icon {
    width: 48px;
    height: 48px;
    margin: 0 auto 10px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e1f5fe;
    color: #0288d1;
    font-size: 20px;
    border: 1px solid #b3e5fc;
  }
  .mce-empty__title {
    font-size: 15px;
    font-weight: 800;
    color: #334155;
  }
  .mce-empty__sub {
    font-size: 13px;
    margin-top: 4px;
  }
  .mce-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 220px;
    overflow-y: auto;
    padding: 10px;
    margin-bottom: 14px;
    border-radius: 14px;
    border: 1.5px solid #b3e5fc;
    background: #fff;
  }
  .mce-chip {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-width: 112px;
    max-width: 100%;
    padding: 9px 14px;
    border-radius: 12px;
    border: 1.5px solid #b3e5fc;
    background: #fff;
    color: #01579b;
    cursor: pointer;
    line-height: 1.2;
    text-align: center;
    transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease;
  }
  .mce-chip:hover {
    border-color: #03a9f4;
    background: #e1f5fe;
    transform: translateY(-1px);
  }
  .mce-chip.is-selected {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
    box-shadow: 0 6px 14px rgba(2, 136, 209, 0.28);
  }
  .mce-chip__name {
    font-size: 12px;
    font-weight: 800;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mce-chip__type {
    font-size: 10px;
    font-weight: 700;
    opacity: 0.88;
    color: #0277bd;
  }
  .mce-chip.is-selected .mce-chip__type {
    color: rgba(255,255,255,0.95);
  }
  .mce-selected {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    padding: 10px 12px;
    border-radius: 12px;
    border: 1.5px solid #80cbc4;
    background: linear-gradient(135deg, #e0f2f1 0%, #ffffff 70%);
  }
  .mce-selected__icon {
    width: 32px;
    height: 32px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #00897b;
    color: #fff;
    flex-shrink: 0;
  }
  .mce-selected__label {
    font-size: 9px;
    font-weight: 800;
    color: #00695c;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .mce-selected__value {
    font-size: 12px;
    font-weight: 800;
    color: #0f172a;
  }
  .mce-selected__type {
    margin-left: auto;
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 800;
    padding: 3px 8px;
    border-radius: 999px;
    background: #00897b;
    color: #fff;
  }
  .mce-form {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 12px;
    padding: 12px;
    border-radius: 14px;
    border: 1.5px solid #b3e5fc;
    background: #fff;
  }
  .mce-form__type {
    grid-column: 1 / -1;
  }
  .mce-type-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .mce-type-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 30px;
    min-width: 0;
    padding: 4px 10px 4px 6px;
    border-radius: 999px;
    border: 1.5px solid #81d4fa;
    background: #fff;
    color: #01579b;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  }
  .mce-type-chip:hover:not(:disabled) {
    border-color: #0288d1;
    background: #e1f5fe;
  }
  .mce-type-chip:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
  .mce-type-chip.is-active {
    background: #33b536;
    border-color: #2a9a2d;
    color: #fff;
  }
  .mce-type-chip__num {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 800;
    background: #e1f5fe;
    color: #0288d1;
  }
  .mce-type-chip.is-active .mce-type-chip__num {
    background: #fff;
    color: #2a9a2d;
  }
  @media (max-width: 640px) {
    .mce-form { grid-template-columns: 1fr; }
  }
  .mce-form .form-group { margin-bottom: 0; }
  .mce-form label {
    display: block;
    margin-bottom: 4px;
    font-size: 10px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .mce-form .form-control {
    min-height: 34px;
    border-radius: 8px;
    border: 1.5px solid #b3e5fc;
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    background: #f8fcff;
  }
  .mce-form .form-control:focus {
    border-color: #03a9f4;
    box-shadow: 0 0 0 3px rgba(3, 169, 244, 0.18);
    background: #fff;
  }
  .mce-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 34px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    border: 1.5px solid transparent;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
  }
  .mce-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
    transform: none !important;
  }
  .mce-btn--ghost {
    background: #fff;
    border-color: #cbd5e1;
    color: #475569;
    margin-right: 8px;
  }
  .mce-btn--ghost:hover:not(:disabled) {
    background: #f1f5f9;
    border-color: #94a3b8;
  }
  .mce-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
    box-shadow: 0 4px 12px rgba(2, 136, 209, 0.28);
  }
  .mce-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(2, 136, 209, 0.34);
  }
`;

function sessionStatusChipStyle(status) {
  const s = String(status || "").trim().toLowerCase();
  const isActive =
    s === "active" ||
    s === "current" ||
    s === "running" ||
    s === "ongoing" ||
    status === "1";
  if (isActive) {
    return { bg: "rgba(16, 185, 129, 0.16)", color: "#047857" };
  }
  return { bg: "rgba(148, 163, 184, 0.22)", color: "#475569" };
}

function CompactSessionSelector({
  sessionName,
  sessionStatus,
  onOpen,
  label = "Source Session",
}) {
  const chip = sessionStatusChipStyle(sessionStatus);
  const displayName = sessionName || "Not set";
  const statusLabel = sessionStatus || "N/A";

  return (
    <button
      type="button"
      className="mce-session-btn"
      onClick={onOpen}
      title="Change source session"
    >
      <span className="mce-session-btn__icon" aria-hidden>
        <i className="fa fa-calendar-alt" />
      </span>
      <span className="mce-session-btn__meta">
        <span className="mce-session-btn__eyebrow">{label}</span>
        <span className="mce-session-btn__name">{displayName}</span>
      </span>
      <span
        className="mce-session-btn__status"
        style={{ background: chip.bg, color: chip.color }}
      >
        {statusLabel}
      </span>
      <span className="mce-session-btn__change">
        Change <i className="fa fa-chevron-right" style={{ fontSize: 10 }} aria-hidden />
      </span>
    </button>
  );
}

const MdlCopyAndCreateExam = ({
  targetSessionId,
  targetSessionName,
  onClose,
  onSuccess,
}) => {
  const loggedIn = useMemo(
    () => localStorage.getItem("token") !== null,
    []
  );

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mExamList, setMExamList] = useState([]);
  const [examId, setExamId] = useState("");
  const [examName, setExamName] = useState("");
  const [examType, setExamType] = useState("EXAM");
  const [newExamName, setNewExamName] = useState("");
  const [newExamRemark, setNewExamRemark] = useState("");
  const [selectedPosition, setSelectedPosition] = useState(0);
  const [sourceSessionName, setSourceSessionName] = useState("");
  const [sourceSessionStatus, setSourceSessionStatus] = useState("");

  const applySelectionFromList = useCallback((list, position) => {
    if (!list || list.length === 0) {
      setExamId("");
      setExamName("");
      setExamType("EXAM");
      setNewExamName("");
      setNewExamRemark("");
      return;
    }
    const item = list[position] ?? list[0];
    const pos = list[position] ? position : 0;
    const type = normalizeExamType(item.exam_type);
    setSelectedPosition(pos);
    setExamId(item.exam_id);
    setExamName(item.exam_name);
    setExamType(type);
    setNewExamName(item.exam_name ? `${item.exam_name} (Copy)` : "");
    setNewExamRemark(item.exam_remark || "");
  }, []);

  const getExamList = useCallback(
    (activeSessionId) => {
      setLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      axios
        .get(`${API_BASE()}getExamList.php`, {
          params: {
            school_code: SCHOOL_CODE,
            session_id: activeSessionId || "",
          },
        })
        .then((res) => res.data)
        .then((response) => {
          setLoading(false);
          if (response.api_status === "OK") {
            const list = response.data || [];
            setMExamList(list);
            applySelectionFromList(list, 0);
          } else {
            setMExamList([]);
            applySelectionFromList([], 0);
            myToast.notify_warning(
              response.api_remark || "Failed to load exams"
            );
          }
        })
        .catch((error) => {
          setLoading(false);
          setMExamList([]);
          console.error("getExamList error:", error);
          myToast.notify_error("Failed to load exams");
        });
    },
    [applySelectionFromList]
  );

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession[0]) {
      const sid = mSession[0].session_id;
      setSourceSessionName(mSession[0].session_name);
      setSourceSessionStatus(mSession[0].status);
      getExamList(sid);
    } else {
      getExamList("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  const selectExam = useCallback((item, position) => {
    const type = normalizeExamType(item.exam_type);
    setExamId(item.exam_id);
    setExamName(item.exam_name);
    setExamType(type);
    setSelectedPosition(position);
    setNewExamName(item.exam_name ? `${item.exam_name} (Copy)` : "");
    setNewExamRemark(item.exam_remark || "");
  }, []);

  const handleSelectedSession = useCallback(
    (sid, sname, sstatus) => {
      setSourceSessionName(sname);
      setSourceSessionStatus(sstatus);
      setIsOpenSessionDialog(false);
      setMExamList([]);
      setExamId("");
      setExamName("");
      setExamType("EXAM");
      setNewExamName("");
      setNewExamRemark("");
      setSelectedPosition(0);
      getExamList(sid);
    },
    [getExamList]
  );

  const handleCopyCreate = useCallback(async () => {
    if (!examId) {
      myToast.notify_warning("Please select an exam to copy");
      return;
    }
    const name = String(newExamName || "").trim();
    if (!name) {
      myToast.notify_warning("Please enter a name for the new exam");
      return;
    }
    if (!targetSessionId) {
      myToast.notify_warning("Target session is missing");
      return;
    }

    const schoolCode = SessionManager.getSchoolCode();
    const staff = SessionManager.getStaffDetails();
    const staffId = staff?.staff_id;
    if (!schoolCode || !staffId) {
      myToast.notify_warning("Staff or school details missing");
      return;
    }

    setSaving(true);
    try {
      const response = await axios.get(`${API_BASE()}copyExam.php`, {
        params: {
          staff_id: staffId,
          school_code: schoolCode,
          session_id: targetSessionId,
          exam_id_old: examId,
          exam_name_new: name,
          exam_remark_new: String(newExamRemark || "").trim(),
          exam_type: examType || "EXAM",
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success(
          response.data?.api_remark || "Exam copied successfully"
        );
        if (onSuccess) onSuccess(targetSessionId);
        if (onClose) onClose();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Could not copy exam"
        );
      }
    } catch (error) {
      console.error("copyExam error:", error);
      myToast.notify_error("Network error while copying exam");
    } finally {
      setSaving(false);
    }
  }, [
    examId,
    examType,
    newExamName,
    newExamRemark,
    targetSessionId,
    onSuccess,
    onClose,
  ]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <style>{DIALOG_STYLES}</style>

      <Modal
        show={!isOpenSessionDialog}
        onHide={handleClose}
        animation={false}
        size="lg"
        dialogClassName="mdl-copy-exam-dialog"
        aria-labelledby="mdl-copy-exam-title"
        centered
        backdrop="static"
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Header closeButton>
          <div className="mce-title" id="mdl-copy-exam-title">
            <span className="mce-title__icon" aria-hidden>
              <i className="fa fa-copy" />
            </span>
            <div className="mce-title__text">
              <div className="mce-title__main">Copy And Create Exam</div>
              <div className="mce-title__session">
                New exam will be created in:{" "}
                <strong>
                  {targetSessionName || targetSessionId || "Current session"}
                </strong>
              </div>
              <div className="mce-title__hint">
                Copies participating classes, subjects, and subject papers from
                the selected exam.
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MyLoader />
            </div>
          ) : (
            <>
              <div className="mce-section">
                <p className="mce-section__label">Source session</p>
                <CompactSessionSelector
                  sessionName={sourceSessionName}
                  sessionStatus={sourceSessionStatus}
                  onOpen={() => setIsOpenSessionDialog(true)}
                  label="Source Session"
                />
              </div>

              {mExamList.length === 0 ? (
                <div className="mce-empty">
                  <div className="mce-empty__icon" aria-hidden>
                    <i className="fa fa-inbox" />
                  </div>
                  <div className="mce-empty__title">No exams in this session</div>
                  <div className="mce-empty__sub">
                    Change source session to pick another exam
                  </div>
                </div>
              ) : (
                <>
                  <div className="mce-section">
                    <p className="mce-section__label">
                      Select exam to copy
                      <span>{mExamList.length} available</span>
                    </p>
                    <div className="mce-chips">
                      {mExamList.map((item, index) => {
                        const isSelected = selectedPosition === index;
                        return (
                          <button
                            key={item.exam_id || index}
                            type="button"
                            className={`mce-chip${isSelected ? " is-selected" : ""}`}
                            onClick={() => selectExam(item, index)}
                            title={
                              item.exam_type
                                ? `${item.exam_name} (${item.exam_type})`
                                : item.exam_name
                            }
                          >
                            <span className="mce-chip__name">{item.exam_name}</span>
                            <span className="mce-chip__type">
                              TYPE: {item.exam_type || "—"}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {examId ? (
                    <div className="mce-selected" aria-live="polite">
                      <span className="mce-selected__icon" aria-hidden>
                        <i className="fa fa-check" />
                      </span>
                      <div>
                        <div className="mce-selected__label">Selected exam</div>
                        <div className="mce-selected__value">{examName}</div>
                      </div>
                      <span className="mce-selected__type">{examType}</span>
                    </div>
                  ) : null}

                  <Form className="mce-form">
                    <Form.Group className="mce-form__type">
                      <Form.Label>Exam Type</Form.Label>
                      <div
                        className="mce-type-chips"
                        role="group"
                        aria-label="Exam type"
                      >
                        {EXAM_TYPES.map((type, idx) => (
                          <button
                            key={type.value}
                            type="button"
                            className={`mce-type-chip${
                              examType === type.value ? " is-active" : ""
                            }`}
                            onClick={() => setExamType(type.value)}
                            disabled={!examId || saving}
                          >
                            <span className="mce-type-chip__num">{idx + 1}</span>
                            {type.label}
                          </button>
                        ))}
                      </div>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>New Exam Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={newExamName}
                        onChange={(e) => setNewExamName(e.target.value)}
                        placeholder="Enter name for the new exam"
                        disabled={!examId || saving}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Remark (optional)</Form.Label>
                      <Form.Control
                        type="text"
                        value={newExamRemark}
                        onChange={(e) => setNewExamRemark(e.target.value)}
                        placeholder="Exam remark"
                        disabled={!examId || saving}
                      />
                    </Form.Group>
                  </Form>
                </>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="mce-btn mce-btn--ghost"
            onClick={handleClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="mce-btn mce-btn--primary"
            onClick={handleCopyCreate}
            disabled={!examId || saving || loading}
          >
            <i className="fa fa-copy" aria-hidden />
            {saving ? "Creating…" : "Copy And Create"}
          </button>
        </Modal.Footer>
      </Modal>

      {isOpenSessionDialog ? (
        <MdlSelectSession
          stacked
          action={() => setIsOpenSessionDialog(false)}
          action2={handleSelectedSession}
        />
      ) : null}
    </div>
  );
};

export default MdlCopyAndCreateExam;
